export default "__VITE_ASSET__BKQWoUnO__"